import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoResultComponent } from '@uc/shared/ui';
import { UniversityCardComponent, UniversitiesSkeletonComponent } from '@web/shared/ui';
import { UniversitiesStore } from '../../data-access/+state/universities.store';
import { Product, UniversityDetails } from '@uc/web/shared/data-models';
import { getDetailByProduct } from '@uc/web/core';
import { UniversityPaginationComponent } from '../university-pagination/university-pagination.component';

@Component({
	selector: 'uc-universities-list',
	imports: [
		CommonModule,
		UniversityCardComponent,
		NoResultComponent,
		UniversitiesSkeletonComponent,
		UniversityPaginationComponent,
	],
	templateUrl: './universities-list.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversitiesListComponent {
	readonly store = inject(UniversitiesStore);
	product = input.required<Product>();
	searchTerm = this.store.payload.name;

	getDetailByProduct(
		university: UniversityDetails,
		key: 'cover_image' | 'external_url' | 'external_prospectus_url',
		product: Exclude<Product, 'clearing'> | null,
	) {
		return getDetailByProduct(university, key, product);
	}
}
